import React, { createContext, useContext, useEffect, useState } from "react";
import { isOnSale } from "./sale";

const CartContext = createContext(null);

const KEY = "bleak_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, size, color, qty = 1) => {
    const activeSale = isOnSale(product);
    const chargedPrice = activeSale ? Number(product.sale_price) : Number(product.price);
    setItems((prev) => {
      const idx = prev.findIndex((p) => p.product_id === product.id && p.size === size && p.color === color);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          slug: product.slug,
          name: product.name,
          price: chargedPrice,
          original_price: product.price,
          on_sale: activeSale,
          image_url: product.image_url,
          size,
          color,
          quantity: qty,
        },
      ];
    });
  };

  const remove = (product_id, size, color) => {
    setItems((prev) => prev.filter((p) => !(p.product_id === product_id && p.size === size && p.color === color)));
  };

  const updateQty = (product_id, size, color, qty) => {
    setItems((prev) => prev.map((p) =>
      p.product_id === product_id && p.size === size && p.color === color ? { ...p, quantity: Math.max(1, qty) } : p
    ));
  };

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, updateQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be inside CartProvider");
  return ctx;
};
